const FourohFour = () => {
   return (
     <section className="content">
     <h1>Page not found</h1>
     <p>Sorry, this page couldn't be found.</p>
     </section>
   )
}
export default FourohFour;
